import { ProductSearchResults } from '../../types/service-response'

export class ProductSearchResult {
  public constructor (
    readonly compKey: string| null,
    readonly auslieferort: number,
    readonly produkt: number,
    readonly produktNummer: string | null,
    readonly auslieferortName: string | null,
    readonly produktBarcode: string | null,
    readonly produktSortierung: string | null,
    readonly produktKlassifizierung: string | null,
    readonly produktBeschreibung: string | null,
    readonly produktBezeichnung: string | null,
    readonly produktGesperrt: boolean,
    readonly ersatz: number,
    readonly produktGruppeCode: string | null,
    readonly produktGruppeBezeichnung: string | null,
    readonly lager: number,
    readonly lagerCode: string | null,
    readonly lagerName: string | null,
    readonly lagerfach: string | null,
    readonly bevorzugt: boolean,
    readonly bestand: number,
    readonly bestellt: number,
    readonly reserviert: number,
    readonly verfuegbar: number,
    readonly einheit: number,
    readonly einheitCode: string| null,
    readonly einheitBezeichnung: string| null,
    readonly ertrag: number,
    readonly aufwand: number,
    readonly hauptKTR: number,
    readonly nebenKTR: number,
    readonly fontColor: string | null,
    readonly sorter: number,
    readonly lagerung: number
  ) {}

  static createFromResponse (responseData: ProductSearchResults[]): Array<ProductSearchResult> {
    let result: Array<ProductSearchResult> = []
    if (responseData) {
      result = responseData.map((item: ProductSearchResults) => {
        return new ProductSearchResult(
          item.CompKey,
          item.Auslieferort,
          item.Produkt,
          item.ProduktNummer,
          item.AuslieferortName,
          item.ProduktBarcode,
          item.ProduktSortierung,
          item.ProduktKlassifizierung,
          item.ProduktBeschreibung,
          item.ProduktBezeichnung,
          item.ProduktGesperrt,
          item.Ersatz,
          item.ProduktGruppeCode,
          item.ProduktGruppeBezeichnung,
          item.Lager,
          item.LagerCode,
          item.LagerName,
          item.Lagerfach,
          item.Bevorzugt,
          item.Bestand,
          item.Bestellt,
          item.Reserviert,
          item.Verfuegbar,
          item.Einheit,
          item.EinheitCode,
          item.EinheitBezeichnung,
          item.Ertrag,
          item.Aufwand,
          item.HauptKTR,
          item.NebenKTR,
          item.FontColor,
          item.Sorter,
          item.Lagerung
        )
      })
    }
    return result
  }
}
